import { createAsyncThunk } from "@reduxjs/toolkit";
import { ordersApi } from "api/orders";
import {
  MemberAllOrderItemRaw,
  MemberAllOrderResponseRaw,
  MemberAllOrderResponseType,
  MemberOrderPayload,
  MemberOrderRewardResponseType,
  MemberPromotionPayload,
} from "api/orders/type";
import { OrderType } from "enums/orders";
import { MemberOrderType } from "types/orders";

const normalizeMemberAllOrderItem = (
  item: MemberAllOrderItemRaw
): MemberOrderType => ({
  status: item.status,
  type: item.method,
  bank_name: item.bank_name,
  bank_account_name: "",
  bank_account_no: item.bank_account_no,
  amount: item.amount,
  reward: item.amount,
  transaction_code: "",
  transaction_id: "",
  currency_id: "",
  currency_code: "",
  currency_rate: "",
  create_date: item.created_date,
  update_date: item.created_date,
  queue: "",
  remark: "",
  method: item.method,
  promotion: item.promotion,
  total_turnover: item.total_turnover,
  current_turnover: item.current_turnover,
  is_reward: item.is_reward,
  reward_amount: item.reward_amount,
  total_amount: item.total_amount,
});

const normalizeMemberAllOrderResponse = (
  response: MemberAllOrderResponseRaw
): MemberAllOrderResponseType => ({
  status: response.status,
  msg: response.msg,
  data: Array.isArray(response.data)
    ? response.data.map(normalizeMemberAllOrderItem)
    : [],
  currentPage: response.currentPage,
  pageSize: response.pageSize,
  totalCount: response.totalCount,
  totalPages: response.totalPages,
  summary: response.total_data
    ? {
        total_deposit: response.total_data.total_deposit,
        total_withdrawal: response.total_data.total_withdrawals,
        total_promotion: response.total_data.total_promotion,
        total_bonus: response.total_data.total_bonus,
        total_winloss: response.total_data.total_winloss,
      }
    : null,
});

export const getMemberAllHistoryOrders = createAsyncThunk<
  MemberAllOrderResponseType,
  MemberOrderPayload,
  { rejectValue: unknown }
>(
  "orders/getMemberAllHistoryOrders",
  async (payload: MemberOrderPayload, { rejectWithValue }) => {
    try {
      payload.type = OrderType.ALL;
      const dataMemberOrder = await ordersApi.memberOrder(
        payload.username,
        payload
      );
      return normalizeMemberAllOrderResponse(
        dataMemberOrder as unknown as MemberAllOrderResponseRaw
      );
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMemberDepositOrders = createAsyncThunk(
  "orders/getMemberDepositOrders",
  async (payload: MemberOrderPayload, { rejectWithValue }) => {
    try {
      payload.type = OrderType.DEPOSIT;
      const dataMemberOrder = await ordersApi.memberOrder(
        payload.username,
        payload
      );
      return dataMemberOrder;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMemberWithdrawalOrders = createAsyncThunk(
  "orders/getMemberWithdrawalrders",
  async (payload: MemberOrderPayload, { rejectWithValue }) => {
    try {
      payload.type = OrderType.WITHDRAWAL;
      const dataMemberOrder = await ordersApi.memberOrder(
        payload.username,
        payload
      );
      return dataMemberOrder;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMemberRebateOrders = createAsyncThunk(
  "orders/getMemberRebateOrders",
  async (payload: MemberOrderPayload, { rejectWithValue }) => {
    try {
      payload.type = OrderType.REBATE;
      const dataMemberOrder = await ordersApi.memberOrderRebate(
        payload.username,
        payload
      );
      return dataMemberOrder;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getMemberRewardOrders = createAsyncThunk<
  MemberOrderRewardResponseType,
  MemberOrderPayload,
  { rejectValue: unknown }
>(
  "orders/getMemberRewardOrders",
  async (payload: MemberOrderPayload, { rejectWithValue }) => {
    try {
      payload.type = OrderType.REWARD;
      const dataMemberOrder = await ordersApi.memberOrderReward(
        payload.username,
        payload
      );
      return dataMemberOrder as MemberOrderRewardResponseType;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMemberPromotions = createAsyncThunk(
  "orders/getMemberPromotions",
  async (payload: MemberPromotionPayload, { rejectWithValue }) => {
    try {
      const result = await ordersApi.memberPromotion(payload.username, payload);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
